import angular from 'angular';
import 'daterangepicker';

function Directive() {
  return {
    restrict: 'E',
    replace: true,
    require: 'ngModel',
    scope: {
      datePickerOptions: '=',
      singleDatePicker: '@',
      opens: '@',
      trigger: '='
    },
    template: `<div class="date-range-picker-single">
    <input class="form-control" type="text" />
    </div>`,
    link(scope, element, attrs, ngModelCtrl) {
      let picker;

      scope.datePickerOptions = scope.datePickerOptions || {};
      scope.parentEl = element;

      scope.datePickerOptions.handle = {
        show() {
          picker.data('daterangepicker').show();
        },
        hide() {
          picker.data('daterangepicker').hide();
        }
      };

      if (scope.trigger === true) {
        scope.datePickerOptions.init = function() {
          init();

          picker.data('daterangepicker').setStartDate(ngModelCtrl.$viewValue);
        };
      } else {
        scope.datePickerOptions.init = function() {};

        init();
      }

      function init() {
        const options = {};

        angular.extend(options, scope.datePickerOptions);

        const inlineOptions = {};

        if (scope.opens) {
          inlineOptions.opens = scope.opens;
        }

        inlineOptions.singleDatePicker = true;

        angular.extend(options, inlineOptions);

        picker = element.find('input')
          .daterangepicker(options, start => {
            ngModelCtrl.$setViewValue(start);
          });

        ngModelCtrl.$formatters.push(function(modelValue) {
          return modelValue;
        });

        ngModelCtrl.$render = function() {
          if (ngModelCtrl.$viewValue) picker.data('daterangepicker').setStartDate(ngModelCtrl.$viewValue);
        };

        ngModelCtrl.$parsers.push(function(viewValue) {
          return viewValue;
        });

        element.on('show.daterangepicker', function() {
          scope.safeApply(function() {
            if (scope.datePickerOptions.onShow) scope.datePickerOptions.onShow();
          });
        });

        element.on('hide.daterangepicker', function() {
          scope.safeApply(function() {
            if (scope.datePickerOptions.onHide) scope.datePickerOptions.onHide();
          });
        });
      }

      scope.safeApply = function(fn) {
        //https://coderwall.com/p/ngisma/safe-apply-in-angular-js
        const phase = this.$root.$$phase;

        if (phase === '$apply' || phase === '$digest') {
          if (fn && (typeof(fn) === 'function')) { //eslint-disable-line
            fn();
          }
        } else {
          this.$apply(fn);
        }
      };
    }
  };
}

Directive.$inject = [];

export default Directive;



// WEBPACK FOOTER //
// ./src/directives/dateRangePickerSingle/index.js